import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import ProjectsEvents from './ProjectsEvents';

import ProjectsDetailsSectionInfo from './details/sections/ProjectsDetailsSectionInfo';
import ProjectsDetailsSectionSecondaryInfo from './details/sections/ProjectsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<ProjectsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<ProjectsDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="proj_descriptionhtml"
				value={props.model.proj_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_FLOW_SECTION" />
			<DetailsSectionFlowContent module="projects" {...props} />
		</>
	),
	events: ProjectsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
